import { render, staticRenderFns } from "./CooperationList.vue?vue&type=template&id=1aaa7e06"
import script from "./CooperationList.vue?vue&type=script&lang=js"
export * from "./CooperationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports